import type { SVGProps } from 'react';

export const SvgIconNavApp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48" fill="none" {...props}>
    <g clipPath="url(#icon-nav-app_svg__a)">
      <path
        fill="#A7D5E2"
        stroke="#FF0019"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M39.043 10.683c.345.195.626.668.618 1.053l-.082 29.578c0 .389-.281.543-.625.349l-13.026-7.374c-.344-.194-.625-.667-.621-1.052l.086-29.575c0-.389.28-.543.625-.348l13.03 7.37z"
      />
      <path
        fill="#FF0019"
        stroke="#FF0019"
        strokeWidth={1.5}
        d="M34.088 10.716c.206.118.374.4.374.635s-.168.326-.374.209l-3.125-1.768a.8.8 0 0 1-.375-.634c0-.235.169-.326.375-.209z"
      />
      <path
        fill="#FF0019"
        stroke="#FF0019"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m40.724 17.39.019-6.567c0-.389-.277-.858-.622-1.052L26.46 2.04c-.172-.095-.329-.106-.441-.04l-.756.429c.112-.066.27-.055.441.04l13.662 7.73c.345.194.625.667.622 1.052l-.023 6.567c.37.209.648.678.648 1.067l-.008 3.252-.625.356-.078 19.66c0 .194-.072.326-.184.392l.756-.429c.113-.066.184-.198.184-.392l.078-19.363.446-.257c.112-.066.183-.198.183-.392l.008-3.264c0-.388-.278-.858-.648-1.067z"
      />
      <path
        fill="#FF0019"
        d="M39.968 17.822c.37.209.648.678.648 1.067l-.008 3.263c0 .389-.28.543-.625.348l-.078 19.66c0 .39-.281.543-.626.349l-13.658-7.733c-.344-.194-.625-.667-.621-1.052l.086-30.906c0-.389.28-.542.625-.348l13.662 7.729c.344.194.625.667.618 1.052l-.019 6.567h-.004zm-.385 23.488.082-29.578c0-.389-.277-.858-.618-1.053L26.018 3.313c-.344-.194-.625-.037-.625.348l-.082 29.579c0 .389.277.858.621 1.052l13.03 7.37c.344.194.624.037.624-.348z"
      />
      <path
        stroke="#FF0019"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m39.583 41.31.082-29.578c0-.389-.277-.858-.618-1.053L26.018 3.313c-.344-.194-.625-.037-.625.348l-.082 29.579c0 .389.277.858.621 1.052l13.03 7.37c.344.194.624.037.624-.348zm.385-23.488c.37.209.648.678.648 1.067l-.008 3.263c0 .389-.28.543-.625.348l-.078 19.66c0 .39-.281.543-.626.349l-13.658-7.733c-.344-.194-.625-.667-.621-1.052l.086-30.906c0-.389.28-.542.625-.348l13.662 7.729c.344.194.625.667.618 1.052l-.019 6.567h-.004z"
      />
      <path
        fill="#ABDCE9"
        d="m10.533 13.802-1.98 5.563c-.393 1.164.256 2.419 1.444 2.8 1.176.381 2.453-.246 2.85-1.398l.285-.828"
      />
      <path
        fill="#FF0019"
        d="M11.533 42.28c-.996.566-1 1.48-.013 2.042.992.566 2.603.566 3.6 0l2.451-1.386c.996-.565 1-1.48.013-2.041-.992-.566-2.603-.566-3.599 0zM16.45 44.92c-.996.566-1 1.48-.012 2.041.992.566 2.603.566 3.599 0l2.452-1.385c.996-.566 1-1.48.012-2.042-.991-.565-2.602-.565-3.598 0z"
      />
      <path
        fill="#fff"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M21.024 28.15c.372 6.448-.096 17.119-.096 17.119-1.498 1.537-3.64 1.012-4.6.147l-1.765-14.114 1.033 11.83c-1.029.747-2.716.669-3.996-.298 0 0-.573-6.022-1.193-13.635l-.28-3.886c3.85 1.246 7.085 4.19 10.901 2.84h-.004z"
      />
      <path
        fill="#F9DDD6"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M31.8 18.783c2.38.037 1.397-1.746 1.787-1.882 1.996-.709 1.13-2.197-.804-1.598-1.071.336-1.632-.238-2.507.782-.987 1.152-.493 2.665 1.524 2.698"
      />
      <path
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m10.29 13.7-1.98 5.562c-.393 1.164.256 2.419 1.445 2.8 1.175.381 2.452-.246 2.85-1.398l.284-.828"
      />
      <path
        fill="#ABDCE9"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M10.395 14.027c.167-2.258.98-3.828 3.687-3.037 2.912.848 4.52 1.369 5.75 1.775 1.23.401 5.168 1.262 5.168 1.262l5.5 1.157-.5 3.918-9.223-1.147.528 10.527c-2.95 2.517-11.5-.705-11.337-1.988 0 0 .218-3.694.272-5.24.117-1.947-.004-4.972.16-7.23h.003z"
      />
      <path
        fill="#F6DAD4"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M16.065 13.503c-2.69-.308-4.62-2.698-4.306-5.334.314-2.64 2.754-4.525 5.449-4.218 2.69.308 4.62 2.698 4.306 5.333s-2.754 4.526-5.445 4.219z"
      />
      <path
        fill="#FF0019"
        d="M19.9 9.928a.846.846 0 0 1-.746-.924c.052-.452.48-.782.943-.731a.84.84 0 0 1 .747.923c-.052.458-.476.782-.943.732M20.179 5.312l-1.398 1.763-.276 2.324c-.075.373-.594.426-.745.074l-.263-.62s-.578-.684-1.206-.397c-.627.287-.837 1.935.402 2.898.649.505-.025 2.44-.025 2.44l-3.946-1.87-.963-3.763 1.205-2.878 2.67-1.303 3.21.102 1.335 1.226h-.004z"
      />
      <path
        stroke="#FF0019"
        strokeWidth={1.5}
        d="M4 1.96h4M6 0v3.918M.25 19.592h4M2.25 17.633v3.918M43.25 6.857h4M45.25 4.898v3.918"
      />
    </g>
    <defs>
      <clipPath id="icon-nav-app_svg__a">
        <path fill="#fff" d="M0 0h48v48H0z" />
      </clipPath>
    </defs>
  </svg>
);
